import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { useState } from 'react';
import { Button } from 'primereact/button';
import { useContextAdminHora } from './ContextAdminHorario';
import { adicionaHorario } from '../../services/HorarioTurno/TurnoService';

const NuevoHorario = ({ ocultaDialogNuevo }) => {

    const [sigla, setSigla] = useState('')
    const [nombre, setNombre]= useState('')
    const [descripcion, setDescripcion]= useState('')
    const [libre, setLibre] = useState(false)
    const [ctrlDisable, setCtrlDisable] = useState(false)

    const showToast = useContextAdminHora()

    const registraHorario = async () => {
        if (sigla.length === 0 ) {
            showToast('warn', 'Warn', 'Debe llenar el campo Sigla')
            return 
        }
        if (nombre.length === 0 ) {
            showToast('warn', 'Warn', 'Debe llenar el campo Nombre')
            return
        }
        if (descripcion.length === 0 ) {
            showToast('warn', 'Warn', 'Debe llenar el campo Descripcion')
            return 
        }

        const objPost = {
            sigla: sigla,
            nombre: nombre,
            descripcion: descripcion,
            esLibre: libre
        }
        setCtrlDisable(true)
        try {
            const datos = await adicionaHorario(objPost)
            if (datos.horarioId) {
                showToast('success', 'Success', 'Adicon ejecutada con exito')
            }
        } catch (error) {
            console.error (error.message)
            showToast('error', 'Error', 'Error al registrar')
        } finally {
            setCtrlDisable(true)
            ocultaDialogNuevo()
        }
    }

    return (
        <div className="card">
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-6">
                    <label htmlFor="">Sigla:</label>
                    <InputText value={sigla} onChange={(e) => setSigla(e.target.value)} autoComplete='off' />
                </div>
                <div className="field col-12 md:col-6">
                    <label htmlFor="">Nombre:</label>
                    <InputText value={nombre} onChange={(e) => setNombre(e.target.value)} autoComplete='off' />
                </div>
                <div className="field col-12 md:col-12">
                    <label htmlFor="">Descripcion:</label>
                    <InputText value={descripcion} onChange={(e) => setDescripcion(e.target.value)} autoComplete='off' />
                </div>
                <div className="field col-12 md:col-6">
                    <Checkbox checked={libre} onChange={(e)=> setLibre(e.checked) } /> {'  '}
                    <label htmlFor="">Es libre</label>
                </div>
                <div className="field col-12 md:col-6">
                    <div className='flex justify-center gap-2'>
                        <Button label='Cancelar' onClick={ocultaDialogNuevo} disabled={ctrlDisable} />
                        <Button label='Registrar' disabled={ctrlDisable} onClick={registraHorario} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NuevoHorario;
